import { render, staticRenderFns } from "./DictForm.vue?vue&type=template&id=1352c7b2"
import script from "./DictForm.vue?vue&type=script&lang=js"
export * from "./DictForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports